import React, { useState, useEffect } from "react";
import {
  Box,Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import InputLabel from "@mui/material/InputLabel";
import TextField from '@mui/material/TextField';
import moment from "moment";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

const LoadingOverlay = ({ loading, children }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0)", // Semi-transparent white background
            backdropFilter: "blur(1px)", // Apply blur effect
            zIndex: 10, // Ensure loader is on top
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box sx={{ opacity: loading ? 0.5 : 1, transition: "opacity 0.3s" }}>
        {children}
      </Box>
    </Box>
  );
};

export default function FormDialog(props) {
  const { InstanceID, name, status, spent, budget, billingtype, lab_id, start_date, start_time, end_date, end_time, number_of_trainee, application } = props;

  const [open, setOpen] = React.useState(false);
  const [bopen, setBOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [hOpen, setHOpen] = React.useState(false);
  const [updatedBudgetHours, setUpdatedBudgetHours] = useState(0);
  // const [usageHoursPerDay, setUsageHoursPerDay] = useState(0);
  const [maxBudgetHours, setMaxBudgetHours] = useState(0);
  const [budgetError, setBudgetError] = useState(false);
  const [budgetErrorMsg, setBudgetErrorMsg] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [numberfind, setnumberfind] = React.useState(false);
  // const [open3, setOpen3] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const [state, setState] = React.useState({
    new_budget_Amt: ""
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  const handleClose1 = () => {
    setBOpen(false);
  };

  const handleHourlyBudgetClose = () => {
    setHOpen(false);
  };

  const Edit = () => (e) => {
    e.preventDefault();
    if (parseInt(budget) < state.new_budget_Amt) {
      let newAmount = parseInt(state.new_budget_Amt) - parseInt(budget)
      let available = localStorage.getItem("available");
      if (newAmount <= available && available > 0) {
        const newBudgetAmount = {
          new_amount: state.new_budget_Amt,
        };
        fetch(`${process.env.REACT_APP_API_URL}/api/uncordonedsvmlab/${InstanceID}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify(newBudgetAmount)
          }
        )
          .then((response) => response.json())
          .then((data) => {
            handleClose();
          })
          .catch((error) => {
            window.location.reload();
          });
      } else {
        setOpen(true);
      }
    }
    else {
      setOpen2(true);
    }

  };

  const onHourlyBudgetUpdateClick = async (e) => {
    e.preventDefault();
    setLoading(true);

    let isComponentMounted = true; // Track whether the component is still mounted

    const instancedata = {
      lab_id: lab_id,
      labtype: "sharedvm",
      nooftrainee: number_of_trainee,
      budgethours: updatedBudgetHours,
      machine_count: 0
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/uncordonbudgethourscalculation/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(instancedata),
      });
      const data = await response.json();
      // console.log("data", data);
      if (isComponentMounted) { // Only update state if the component is still mounted
        if (data === "proceed") {
          setHOpen(false);
          setError(false);
          setErrorMessage("");
        } else if (data === "not proceed") {
          setOpen(true);
          // setError(false);
          // setErrorMessage("");
        }else {
          setError(true);
          setErrorMessage("Something went wrong");
        }

      }
    } catch (error) {
      if (isComponentMounted) {
        setError(true);
        setErrorMessage("Something went wrong");
        setLoading(false);
      }
      console.error("Error fetching budget hours calculation:", error);
    }
    setLoading(false);
    setHOpen(false);
    return () => {
      isComponentMounted = false; // Cleanup to mark the component as unmounted
    };
  };


  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (billingtype === "budgetbased") {
      setBOpen(true);
    } else if (billingtype === "hourlybased") {
      setnumberfind(true);
      if (end_date && end_time) {
        var local_Time = new Date();
        var hoursUTC = String(local_Time.getUTCHours()).padStart(2, "0");
        var minutesUTC = String(local_Time.getUTCMinutes()).padStart(2, "0");
        const currentDateTime = moment(`${hoursUTC}:${minutesUTC}`, "HH:mm");
        const endDateTime = moment(`${end_date} ${end_time}`, "YYYY-MM-DD HH:mm");
        const differenceInMilliseconds = endDateTime.diff(currentDateTime);
        const differenceInHours = differenceInMilliseconds / 3600000;

        setMaxBudgetHours(differenceInHours);
      }
      setHOpen(true);
    }
  };


  const handleBudgetHoursChange = (e) => {
    const inputHours = e.target.value;
    // Allow setting the value as the user types, even if it might be invalid
    setUpdatedBudgetHours(inputHours);
    setnumberfind(false);
    // const inputValue = e.target.value;

    if (inputHours === "") {
      setnumberfind(true);  // Disable the button if input is empty
      setBudgetErrorMsg("Input cannot be empty");
      setBudgetError(true);
      return;  // Exit the function early
    }
  
    // Ensure the value is a positive integer
    if (/^[0-9]*$/.test(inputHours)) {
      const numericValue = parseInt(inputHours, 10);
      if (numericValue <= 0) {
        setnumberfind(true);
      } else {
        // Validate the input
        if (inputHours === "" || parseInt(inputHours) <= parseInt(maxBudgetHours)) {
          setBudgetErrorMsg("");
          setBudgetError(false);
        } else {
          setBudgetErrorMsg(`Please enter budget hours below ${parseInt(maxBudgetHours)} hours`);
          setBudgetError(true);
        }
      }
    }else{
      // Input contains invalid characters (non-numeric)
      setnumberfind(true);
    }
  };

  return (
    <div>
      {status === "Cordoned" ? (
        <React.Fragment>
          <MenuItem onClick={handleSubmitClick}>
            <IconButton aria-label="delete">
              <RemoveCircleOutlineOutlinedIcon />
            </IconButton>
            <span style={{ fontSize: "0.7em", color: "#172B4D" }}>UnCordoned</span>
          </MenuItem>
        </React.Fragment>
      ) : (
        ""
      )}
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogTitle id="form-dialog-title">
          Please check the Available Balance!
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Not enough balance in your account.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={open2} onClose={handleClose2} maxWidth="md">
        <DialogTitle id="form-dialog-title">
          {/* Please check the Available Balance! */}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            New budget is less that old budget.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose2} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={bopen} onClose={handleClose1} aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            height: '260px'
          }
        }}
        fullWidth>
        <DialogTitle id="form-dialog-title">
          Please provide the new budget:
        </DialogTitle>
        <DialogContent>
          <InputLabel>
            Old Budget Amount
          </InputLabel>
          <TextField
            fullWidth
            name="Old_Budget_Amount"
            id="Old_Budget_Amount"
            size="small"
            disabled={true}
            value={budget}
          />
          <br />
          <br />
          <TextField
            fullWidth
            label="New Budget Amount"
            name="new_budget_Amt"
            id="new_budget_Amt"
            size="small"
            onChange={handleChange}
            required
            autoComplete="name"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose1} color="primary">
            Cancel
          </Button>
          <Button onClick={Edit()} color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={hOpen} onClose={handleHourlyBudgetClose} aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            height: '220px'
          }
        }}
        fullWidth>
        <LoadingOverlay loading={loading}>
          <DialogTitle id="form-dialog-title">
            Please provide the new budget hour:
          </DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2 }}>
              <TextField
                type="number"
                id="updatedBudgetHours"
                label="New Budget Hour"
                variant="outlined"
                inputProps={{
                  min: 0,
                  max: maxBudgetHours,
                  step: "1",
                }}
                value={updatedBudgetHours}
                onChange={handleBudgetHoursChange}
                error={!!budgetErrorMsg}
                helperText={budgetErrorMsg}
                fullWidth
                required
              />
              </Box>
            {errorMessage && (
              <Typography color="error" align="left" style={{ marginTop: "10px", fontSize: "13px", lineHeight: "1.2" }}>
                {errorMessage}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleHourlyBudgetClose} color="primary">
              Cancel
            </Button>
            <Button 
              onClick={onHourlyBudgetUpdateClick} 
              color="primary"
              disabled={numberfind || budgetErrorMsg || loading} // Disable if there's an error or loading is true
            >
              Update
          </Button>
          </DialogActions>
        </LoadingOverlay>
      </Dialog>
    </div>
  );
}
